import { render, staticRenderFns } from "./RequestResetPin.vue?vue&type=template&id=2cde38b9&scoped=true&"
import script from "./RequestResetPin.vue?vue&type=script&lang=js&"
export * from "./RequestResetPin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cde38b9",
  null
  
)

export default component.exports